import { Component, Inject, OnInit } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { ConfirmDialogData } from './confirm.interface';
import Utils from '@constants/utils';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  pageId: string;
  confirmData: ConfirmDialogData;
  ids: any = {};

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {
    this.confirmData = {
      title: data.title,
      message: data.message,
      confirmText: data.confirmText,
      cancelText: data.cancelText,
      pageName: data.pageName
    };
  }

  ngOnInit(): void {
    this.ids = {
      confirm: Utils.toUpperCamelCase(this.confirmData.confirmText, ' '),
      cancel: Utils.toUpperCamelCase(this.confirmData.cancelText, ' ')
    };
  }

  // Close the dialog
  target(decision: boolean): void {
    this.dialogRef.close(decision);
  }
}
